import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import soundFile from "../assets/sound/boxing_bell.mp3";
import { useTranslation } from "react-i18next";

const useOrderNotification = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const showNewOrderNotification = (data) => {
    const notificationMusic = new Audio(soundFile);
    notificationMusic
      .play()
      .then(() => {
        console.log("Sound played successfully");
      })
      .catch((error) => {
        console.error("Sound error:", error);
      });

    const roundedAmount = Math.round(data?.total_amount * 100) / 100;

    toast.success(`${t("newOrderSubmitted")} ${roundedAmount}`, {
      description: t("doYouWantToAccept"),
      action: {
        label: t("viewButton"),
        onClick: () => navigate(`/admin/orders/${data._id}`),
      },
      position: "top-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      actionButtonStyles: {
        backgroundColor: "green",
        color: "white",
        marginLeft: "10px",
      },
      icon: "🍕",
      important: true,
      style: {
        backgroundColor: "#fef2e8",
        color: "black",
        border: "2px solid #f78220",
      },
    });
  };

  return showNewOrderNotification;
};

export default useOrderNotification;
